/* mutation常量 */
export const SET_USER = 'SET_USER'

export const SET_FAMILY = 'SET_FAMILY'

export const SET_FAMILY_DETAIL = 'SET_FAMILY_DETAIL'

export const SET_CURRENT_CITY = 'SET_CURRENT_CITY'

export const SET_CURRENT_ORG = 'SET_CURRENT_ORG'

export const SET_CURRENT_PAC = 'SET_CURRENT_PAC'

export const SET_CURRENT_ORDER = 'SET_CURRENT_ORDER'

export const SET_INVOICE_TYPE = 'SET_INVOICE_TYPE'

export const SET_CURRENT_CARD = 'SET_CURRENT_CARD'

export const SET_PACKAGE_ORG_REQS = 'SET_PACKAGE_ORG_REQS'

export const SET_AGREE_CMB_EXPLAIN = 'SET_AGREE_CMB_EXPLAIN'
// export const SET_CURRENT_ORDER_TYPE = 'SET_CURRENT_ORDER_TYPE';

export const SET_CCB_DISCOUNT = 'SET_CCB_DISCOUNT'

export const SET_SUB_TITLE = 'SET_SUB_TITLE'

export const SET_NEW_MESSAGE_PROMPT = 'SET_NEW_MESSAGE_PROMPT'

export const SET_COMEFROM = 'SET_COMEFROM'
export const SET_PREVIEW_LIST_IMG = 'SET_PREVIEW_LIST_IMG'
export const SET_DEFAULT_FORM_DATA = 'SET_DEFAULT_FORM_DATA'
